import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { KnockProvider, KnockGuideProvider } from '@knocklabs/react';

import '@knocklabs/react/dist/index.css';

import NPSSurvey from 'components/NPSSurvey';

import { useStore } from 'utils/hooks/store';

import { KnockGuideTheme } from './styles';
import { VatixModal } from './VatixGuides';

const KnockGuidesProvider: React.FC<{ children: React.ReactNode }> = observer(({ children }) => {
  const { session, knockGuides } = useStore();
  const { isAuthenticated } = session;
  const { config } = knockGuides;

  useEffect(() => {
    if (isAuthenticated) {
      knockGuides.loadConfig();
    }
  }, [isAuthenticated, knockGuides]);

  return (
    <KnockProvider
      apiKey={config?.publicApiKey ?? ''}
      user={{ id: config?.userId ?? '' }}
      userToken={config?.token}
      onUserTokenExpiring={knockGuides.fetchToken}
    >
      <KnockGuideProvider channelId={config?.guideChannelId ?? ''} readyToTarget={Boolean(config)}>
        <KnockGuideTheme />
        <VatixModal />
        <NPSSurvey />
        {children}
      </KnockGuideProvider>
    </KnockProvider>
  );
});

export default KnockGuidesProvider;
